module.exports = __webpack_public_path__ + "static/media/vtex38.e449e4a3.png";